module.exports = __webpack_public_path__ + "static/img/shezhi_jiaoyijilu.7ffa492a.png";